<template>
    <div style="height: 100%; overflow: auto">
        <b-card class="sa-card" header="Attivita" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Nome:</label>
                    <b-form-input v-model="jsonData.nomeAttivita"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Area:</label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.idArea" class="mb-2 mr-sm-2 mb-sm-0" :value="''" value-field="id" text-field="nome" :options="areeOptions"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Diario:</label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.idDiario" class="mb-2 mr-sm-2 mb-sm-0" :value="''" value-field="id" text-field="nome" :options="diariOptions"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Form:</label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.idForm" class="mb-2 mr-sm-2 mb-sm-0" :value="''" value-field="id" text-field="titolo" :options="jsonFormOptions">
                        <template #first>
                            <b-form-select-option :value="null" disabled> - Seleziona - </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <!--   <b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <label class="sa-label-data">Tipologia Operatore:</label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.tipologiaOperatore" class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="codice" text-field="codice" :options="tipologiaOperatoreOptions">
                        <template #first>
                            <b-form-select-option :value="null" disabled> - Seleziona - </b-form-select-option>
                        </template></b-form-select
                    >
                </b-col> -->
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Descrizione:</label>
                    <b-form-textarea v-model="jsonData.descrizione" no-resize rows="5"></b-form-textarea>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Gruppi Associati:</label>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <b-form-checkbox v-model="isTuttiChecked" name="check-button" @change="onChangeTutti" switch>Tutti</b-form-checkbox>
                </b-col>
                <b-col v-for="tipologiaUtente in gruppi" :key="tipologiaUtente.id" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <b-form-checkbox v-model="tipologiaUtente.isCheck" name="check-button" switch>{{ tipologiaUtente.nome }}</b-form-checkbox>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="" header-tag="header" footer-tag="footer" title="">
            <template #header>
                <div style="display: flex">
                    <span style="flex: 1">Dettagli Prestazioni</span>
                    <b-button size="sm" variant="outline-secondary outline-secondary-noborder pull-right" @click="onClickCaricaNomenclatore">
                        <i class="bi bi-journals"></i>
                        Carica Da Nomenclatore
                    </b-button>
                </div>
            </template>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Codice Prestazione:</label>
                    <b-form-input v-model="jsonData.codicePrestazione"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
                    <label class="sa-label-data">Descruzione Prestazione:</label>
                    <b-form-input v-model="jsonData.descrizionePrestazione"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Codice Prestazione Agg:</label>
                    <b-form-input v-model="jsonData.codicePrestazioneAgg"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
                    <label class="sa-label-data">Descruzione Prestazione Agg:</label>
                    <b-form-input v-model="jsonData.descrizionePrestazioneAgg"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Importo Prestazione:</label>
                    <b-form-input v-model="jsonData.importoPrestazione"></b-form-input>
                </b-col>
            </b-row>
        </b-card>
        <nomenclatore-list-component ref="cmpNomenclatoreListComponent" @selectedPrestazione="onSelectPrestazione"></nomenclatore-list-component>
    </div>
</template>
<script>
import axios from "axios";
import NomenclatoreListComponent from "../../../utility/components/NomenclatoreListComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    components: { NomenclatoreListComponent },
    mixins: [UtilityMixin],
    data() {
        return {
            pathResource: "/rsaattivita",
            pathResourceDiari: "/rsadiari",
            pathResourceAree: "/rsaaree",
            pathResourceDynamicForm: "/dynamicform",
            pathResourceTipologiaAttivita: "/rsaattivitatipologiaoperatore",
            pathResourceGruppi: "/gruppi",
            id: "-1",
            jsonData: {
                nomeAttivita: "",
                idArea: "",
                idDiario: "",
                tipologiaOperatore: null,
                idForm: null,
                descrizione: "",
                codicePrestazione: "",
                descrizionePrestazione: "",
                codicePrestazioneAgg: "",
                descrizionePrestazioneAgg: "",
                importoPrestazione: null,
                listaGruppi: [],
            },
            //  isTuttiChecked: null,
            areeOptions: [{ id: "", nomeAttivita: "-Seleziona Area-" }],
            diariOptions: [],
            jsonFormOptions: [],
            tipologiaOperatoreOptions: [],
            gruppi: [],
        };
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
        gruppi: {
            handler(listaGruppi) {
                let me = this;
                me.jsonData.listaGruppi = [];
                listaGruppi.forEach((element) => {
                    if (element.isCheck) {
                        me.jsonData.listaGruppi.push({ idSecurityGruppo: element.id, nomeGruppo: element.nome });
                    }
                });
            },
            deep: true,
        },
    },
    computed: {
        isTuttiChecked() {
            return this.gruppi.length === this.jsonData.listaGruppi.length;
        },
    },
    mounted() {
        let me = this;
        me.id = this.$route.params.id;
        me.loadAree();
        me.loadDiari();
        me.loadGruppi();
        me.loadDynamicForm();
    },
    methods: {
        loadData() {
            let me = this;
            me.$emit("beforeLoadData");
            if (me.id === "-1") {
                this.$emit("afterLoadData");
            } else {
                let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
                axios
                    .get(link + me.id)
                    .then((response) => {
                        me.jsonData = response.data.data;
                        me.checkGruppiAssociati(me.jsonData);
                        this.$emit("afterLoadData");
                    })
                    .catch(() => {});
            }
        },
        loadAree() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAree;
            axios
                .get(link)
                .then((response) => {
                    // me.rows = response.data.data.recordsNumber;
                    me.areeOptions = response.data.data.list;
                    me.areeOptions.unshift({
                        id: "",
                        nome: "-Seleziona Area-",
                    });
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
        },
        loadDiari() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceDiari;
            axios
                .get(link)
                .then((response) => {
                    // me.rows = response.data.data.recordsNumber;
                    me.diariOptions = response.data.data.list;
                    me.diariOptions.unshift({
                        id: "",
                        nome: "-Seleziona Diario-",
                    });
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
        },
        /*       loadGruppi() {
            let me = this;
            me.$emit("beforeLoadData");
            let link = process.env.VUE_APP_PATH_API + me.pathResourceTipologiaAttivita;
            axios
                .get(link)
                .then((response) => {
                    console.log(response);
                    me.tipologiaOperatoreOptions = response.data.data.list;
                    this.$emit("afterLoadData");
                })
                .catch(() => {});
        }, */
        loadGruppi() {
            let me = this;
            me.loadDataResources(me.pathResourceGruppi, {}, me.resultResponseGruppi, me.resultErrorGruppi);
        },
        resultResponseGruppi(response) {
            let me = this;
            //me.gruppi = response.data.data;
            response.data.data.forEach((element) => {
                element.isCheck = false;
                me.gruppi.push(element);
            });
            me.loadData();
        },
        resultErrorGruppi(error) {
            console.log(error.response);
        },
        onClickCaricaNomenclatore() {
            let me = this;
            me.$refs.cmpNomenclatoreListComponent.openModal();
        },
        onSelectPrestazione(json) {
            let me = this;
            me.jsonData.codicePrestazione = json.codicePrestazione;
            me.jsonData.codicePrestazioneAgg = json.codicePrestazioneAgg;
            me.jsonData.descrizionePrestazione = json.descrizione;
            me.jsonData.descrizionePrestazioneAgg = json.descrizioneAgg;
            me.jsonData.importoPrestazione = json.importoPrestazione;
        },
        loadDynamicForm() {
            let me = this;
            me.loadDataResources(me.pathResourceDynamicForm, {}, me.resulResponseDynamicForm, me.resulErrorDynamicForm);
        },
        resulResponseDynamicForm(response) {
            let me = this;
            me.jsonFormOptions = [];
            me.jsonFormOptions = response.data.data.list;
            me.jsonFormOptions.unshift({ idForm: null, titolo: "NESSUNO" });
        },
        resulErrorDynamicForm(error) {
            console.log(error);
        },
        checkGruppiAssociati(jsonData) {
            let me = this;
            let setIdGruppi = new Set(jsonData.listaGruppi.map((element) => element.idSecurityGruppo));
            me.gruppi.forEach((gruppo) => {
                gruppo.isCheck = setIdGruppi.has(gruppo.id);
            });
        },
        onChangeTutti(value) {
            let me = this;
            me.gruppi.forEach((element) => {
                //                me.$set(element, "isCheck", value);
                element.isCheck = value;
            });
        },
    },
};
</script>
